import {
  IRequirementDefinitionResponse,
  IRequirementDefinitionUpdateRequest
} from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";

export const updateRequirementDefinition = async (
  id: string,
  payload: IRequirementDefinitionUpdateRequest
): Promise<IRequirementDefinitionResponse> => {
  const response = await servicePayments.patch(
    `/requirement-definition/${id}`,
    payload
  );
  return response.data;
};
